import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import WJH from '@/js/wjhJS.js'
import animated from 'animate.css'
import Share from '@/js/shareAndGetName'
import Tool from './js/tool.js'
import Axios from 'axios'

console.log(process.env.NODE_ENV, process.env.VUE_APP_TITLE)

const URL = process.env.NODE_ENV === 'production' && process.env.VUE_APP_TITLE !== 'experiment' ? 'https://api.psy-1.com' : 'https://api.debug.psy-1.com'

const myAxios = Axios.create({
  baseURL: URL
})

Vue.prototype.WJH = WJH
Vue.prototype.$axios = myAxios

Vue.config.productionTip = false
require('@/js/setSize')
Vue.use(animated)

console.log(
  process.env
)

new Vue({
  router,
  store,
  data () {
    return {
      showBg: false,
      downloadLink: 'https://www.heartide.com/statics/redirect?url=681',
      myData: {},
      done: true,
      url: URL
    }
  },
  methods: {
    toDownLoad () {
      window.location.href = this.downloadLink
    },
    shareM (title = '小睡眠', desc = '', picUrl) {
      // eslint-disable-next-line
      const share = new Share({ pic: picUrl, url: window.location.href.split('#')[0], title: title, desc: desc })
      share.appShare()
      share.rawWeiXinShare(this.url)
    },
    test () {
      if (Tool.is_cosleep()) {
        this.share.appGetName()
      }
      if (/micromessenger/.test(navigator.userAgent.toLowerCase())) {
        this.share.weiXinInit(this.url)
        this.share.weatherCode()
        this.share.weiXinGetName(this.url)
      }
    }
  },
  mounted () {
    const urlParams = this.WJH.parseQuery(decodeURIComponent(window.location.href))
    this.$axios.get('/web/v1/cosleep/sleep/star/detail', { params: { star_id: urlParams.star_id.replace('/', '') } }).then((res) => {
      if (res.data.status === 1) {
        const data = res.data.data
        this.myData = data
        this.shareM(`失眠睡不着？${data.star_name}哄你睡觉`, '爱豆哄睡天团', data.star_avatar)
        this.$store.commit('musicPathSet', this.myData.star_audio_mini)
        /* eslint-disable */
        get.boolean = true
      }
    })
  },
  render: h => h(App)
}).$mount('#app')
